exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-not-mapped[data-v-0ed6570e] .vs__selected {\r\n    color: silver;\n}\r\n", ""]);

// exports
